import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { CurrentExamService } from './current-exam.service';
import { LogStatus, ReportLogLevel } from './enums/report-level.enum';
import { SubmittedExamInformation } from './interfaces/submitted-exam-information.interface';

@Injectable({
  providedIn: 'root'
})
export class ReportExamService {

  constructor(
    private http: HttpClient,
    private currentExamService: CurrentExamService,
    private translateService: TranslateService
  ) { }

  getStatus(flag: boolean){
    return flag ? LogStatus.Success : LogStatus.Failed;
  }
  
  async sendTemplateMessageReport(logLevel: ReportLogLevel, messageTemplate: string, params?: object): Promise<void> {
    const message = this.translateTemplate(messageTemplate, params);
    const offset = new Date().getTimezoneOffset();
    const endpoint = environment.connectedApiUrls.woland + '/' + environment.apiVersions.woland + '/ReportLog/SaveReportLog';
    const model = {
      "examId": this.currentExamService.examMetadata?.id,
      message: JSON.stringify({
        data: message
      }),
      logLevel,
      offset
    };

    return new Promise<void>(resolve => {
      this.http
        .post(endpoint, model)
        .toPromise()
        .then(() => resolve())
        .catch(err => { resolve(); console.log(err) })
    });
  }

  async sendCustomMessageReport(LogType: ReportLogLevel, message: string): Promise<void> {
    const endpoint = environment.connectedApiUrls.woland + '/' + environment.apiVersions.woland + '/ReportLog/SaveReportLog';
    const offset = new Date().getTimezoneOffset();
    const model = {
      "examId": this.currentExamService.examMetadata?.id,
      message,
      LogType,
      offset
    };

    return new Promise<void>(resolve => {
      this.http
        .post(endpoint, model)
        .toPromise()
        .then(() => resolve())
        .catch(err => { resolve(); console.log(err) })
    });
  }

  async getReportForStudent(examId: number, userId: string): Promise<SubmittedExamInformation> {
    const endpoint = environment.connectedApiUrls.woland + '/' 
    + environment.apiVersions.woland + `/ReportLog/GetReportForStudent?examId=${examId}&userId=${userId}`;
    return new Promise<SubmittedExamInformation>((resolve, reject) => {
      this.http
        .get(endpoint)
        .toPromise()
        .then((result: SubmittedExamInformation) => resolve(result))
        .catch(err => { reject(); console.log(err) })
    });
  }

  private translateTemplate(msg: string, params?: object): string {
    return this.translateService.instant(msg, params);
  }

}
